(() => {
  if (window.stB2CGalleryZoomReady) return;
  window.stB2CGalleryZoomReady = true;
  const finePointer = matchMedia('(hover:hover) and (pointer:fine)');
  let active = null;
  const clear = () => { active?.layer.remove(); active = null; };
  const locate = event => {
    if (!finePointer.matches || event.pointerType === 'touch') return null;
    const owner = event.target.closest?.('product-info[data-st-template="b2c"][data-st-hover-zoom="true"] .product__modal-opener--image');
    return owner && owner.querySelector('.product__media > img') ? owner : null;
  };
  const move = event => {
    const owner = locate(event);
    if (!owner) { clear(); return; }
    if (active?.owner !== owner) {
      clear();
      const source = owner.querySelector('.product__media > img');
      const layer = document.createElement('div');
      layer.className = 'st-b2c-detail-zoom';
      layer.setAttribute('aria-hidden', 'true');
      const image = new Image();
      image.alt = '';
      image.onload = () => layer.classList.add('is-ready');
      image.src = source.src;
      layer.append(image);
      source.parentElement.append(layer);
      const zoom = Math.min(3, Math.max(1.5, Number(owner.closest('product-info').dataset.stZoom) || 2));
      image.style.transform = `scale(${zoom})`;
      active = {owner, layer, image};
    }
    const box = owner.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, (event.clientX - box.left) / box.width * 100));
    const y = Math.max(0, Math.min(100, (event.clientY - box.top) / box.height * 100));
    active.image.style.transformOrigin = `${x}% ${y}%`;
  };
  document.addEventListener('pointerover', move, {passive:true});
  document.addEventListener('pointermove', move, {passive:true});
  document.addEventListener('pointerout', event => {
    if (active && !active.owner.contains(event.relatedTarget)) clear();
  }, {passive:true});
  document.addEventListener('change', clear);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
  document.addEventListener('shopify:section:unload', clear);
  window.addEventListener('resize', clear, {passive:true});
})();
